import React from 'react';
import { User } from '@supabase/supabase-js';
import BookIdeaManager from './BookIdeaManager';

interface AuthorDashboardSidebarProps {
  user: User;
}

export default function AuthorDashboardSidebar({ user }: AuthorDashboardSidebarProps) {
  return (
    <aside className="w-80 bg-gray-50 border-l border-gray-200 flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <div className="p-4">
          <BookIdeaManager user={user} />
        </div>
      </div>
    </aside>
  );
}